import type { FaireProductEntity } from "../../entity_types/product";

export const faire_nudge_10: FaireProductEntity = {
  token: "faire_nudge_10",
  type: "product",
  name: "Spiced Apple Candle",
  brandName: "Candle Brand",
  imageUrl:
    "https://images.unsplash.com/photo-1608181831688-305a4c4e0e0a?w=100&h=100&fit=crop",
  priceDollars: 18,
  msrpDollars: 36,
  description: "Migrated candle ops mock product",
  tags: ["candle", "ops"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
